<template>
  <div id="container">
    <div class="box_one" style="margin-bottom:5px"> 
      <cont-top/>
    </div>    

    <div class="main" style="margin-bottom:5px"> 
      <div class="title">
        <div class="title_name"></div>
      </div>

      <div class="clear">
        <el-image
          style="height:242px;width:1px;float:left;margin-right:24px;margin-left:167px"
          :src="require('@/assets/image/moment/newsActivities/img3.png')"
          :fit="fit">
        </el-image>
        <div style="width:269px ;float:left">
          <div class="line">
            <router-link to="BrakeoilClassroom1" tag="div" append>
              <div class="line_item">   更换刹车油的建议 </div>
            </router-link>
          </div>
          <div class="line">
            <router-link to="BrakeoilClassroom2" tag="div" append>
              <div class="line_item">    如何选择刹车油及 DOT 规格 </div>
            </router-link>
          </div>
          <div class="line">
            <router-link to="BrakeoilClassroom3" tag="div" append>
              <div class="line_item">    什么是Super DOT4? </div>
            </router-link>
          </div>
          <div class="line">
            <router-link to="BrakeoilClassroom4" tag="div" append>
              <div class="line_item">    关于赛道用刹车油 </div>
            </router-link>
          </div>
          <div class="line">
            <router-link to="BrakeoilClassroom5" tag="div" append>
              <div class="line_item">    关于如何更换刹车油 </div>
            </router-link>
          </div>
          <div class="line">
            <router-link to="BrakeoilClassroom6" tag="div" append>
              <div class="line_item">    刹车油的沸点 </div>
            </router-link>
          </div>
          <div class="line">
            <router-link to="BrakeoilClassroom7" tag="div" append>
              <div class="line_item">    刹车油的吸湿率 </div>
            </router-link>
          </div>
                                               
        </div>
      </div>

    </div>   

    <div class="box_bottom" > 
      <cont-bottom/>
    </div>

  </div>
</template>

<script>
import ContTop from './Cont_top'
import ContBottom from '@/views/Components/Cont_bottom'


export default {
  data() {
    return {
      fit : 'contain'
    }
  },
  components : {
    ContTop ,
    ContBottom ,
  }
}

</script>

<style lang="stylus" scoped>
.clear:after {
  display: block;
  clear: both;
  content: '';
}

#container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 0 52px;

}
  

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/brandClassroom/BrakeoilClassroom/img1.png');
  background-repeat: no-repeat;
  background-size: contain;
  padding: 40px 42px 40px 42px; 
  box-sizing: border-box;
}

.title_name {
  height: 28px;
  width:  86px;
  background: url('~@/assets/image/brandClassroom/BrakeoilClassroom/img2.png');
  background-repeat: no-repeat;
  background-size: contain;
}

.line{
  display flex
  margin-bottom 10px
}
 .line_item {
   width auto
   line-height 24px
   border-bottom:1px solid #000
   cursor pointer
 }

</style>